var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import colors from '../colors';
import { typography } from './typography';
var TabTypography = __assign({}, typography['body']);
export var MuiTab = {
    styleOverrides: {
        root: __assign(__assign({ padding: 0, minHeight: '25px' }, TabTypography), { marginRight: 0, color: colors.grey[800], minWidth: 'auto', '&:hover': {
                color: colors.grey[900],
            }, '&.Mui-selected': __assign(__assign({}, TabTypography), { color: colors.blue[500], '&:hover': {
                    color: colors.blue[600],
                }, '& .MuiBadge-badge': {
                    background: colors.blue[100],
                } }), '&.Mui-disabled': {
                color: colors.grey[500],
            } }),
    },
};
